import { Controller } from "@hotwired/stimulus"

// Toggles a vehicle (or other owner) preference boolean via POST and applies turbo-stream response.
// Usage: wrap a checkbox with data-controller="preference-toggle"
//   data-preference-toggle-url-value: POST path for toggle_bool_value (no query params)
//   data-preference-toggle-vehicle-id-value: vehicle id for response targeting (optional)
export default class extends Controller {
  static values = {
    url: String,
    vehicleId: { type: String, default: "" }
  }

  toggle(event) {
    const url = this.urlValue
    const vehicleId = this.vehicleIdValue
    const setTo = event.target.checked

    if (!url) {
      console.error("preference-toggle: No URL configured")
      return
    }

    const params = new URLSearchParams()
    params.set("set_to", setTo)
    if (vehicleId) params.set("vehicle_id", vehicleId)

    const csrf = document.querySelector("[name='csrf-token']")?.content

    fetch(`${url}?${params}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "X-CSRF-Token": csrf,
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "text/vnd.turbo-stream.html, text/html, application/xhtml+xml"
      }
    })
      .then(response => {
        const contentType = response.headers.get("content-type") || ""
        const isTurboStream = contentType.includes("turbo-stream")
        if (response.ok && isTurboStream) {
          return response.text().then(html => {
            window.Turbo?.renderStreamMessage(html)
          })
        }
      })
      .catch(err => console.error("preference-toggle error", err))
  }
}
